/**
 * strings.ts
 * ----------------
 * Utility functions for strings.
 */

/**
 * Checks whether a given string is undefined or is empty;
 * @param subject String to check.
 * @returns True if the string is undefined or empty, false otherwise.
 */
export function isUndefinedOrEmpty (subject: string | undefined) {
    return subject === undefined
        || subject.length <= 0;
}

/**
 * Checks whether a given string is undefined or is entirely white space.
 * @param subject String to check.
 * @returns True if the string is undefined or white space, false otherwise.
 */
export function isUndefinedOrWhiteSpace (subject: string | undefined) {
    return isUndefinedOrEmpty(subject)
        || (subject as string).match(/^\s*$/) !== null;
}
